import { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { baseApiService } from "../../../services/api/axios-config/axios-config";
import { SelectField } from "../../ui";

interface SelectContaEmpresaProps {
  name: string;
  methods: any;
  idAgency?: string;
  disabled?: boolean;
  required?: boolean;
  label?: string;
}

export function SelectContaEmpresa({
  name,
  methods,
  idAgency,
  disabled = false,
  required = false,
  label = "Selecione uma Conta",
}: SelectContaEmpresaProps) {
  const [contas, setContas] = useState<any[]>([]);

  useEffect(() => {
    if (!idAgency) {
      setContas([]);
      return;
    }
    const fetchData = async () => {
      const data = await baseApiService.get(
        `bank-registration/select/account/${idAgency}`
      );
      setContas(data.data.data);
    };
    fetchData();
  }, [idAgency]);

  return (
    <Controller
      name={name}
      control={methods.control}
      render={({ field }) => (
        <SelectField
          label={label}
          value={field.value || ""}
          onChange={(e) => field.onChange(e.target.value)}
          required={required}
          disabled={disabled || !idAgency}
        >
          <option value="" />
          {contas.map((conta) => (
            <option key={conta.id} value={conta.id}>
              {`${conta.accountNumber}-${conta.digit}${
                conta?.name ? " - " + conta.name : ""
              }`}
            </option>
          ))}
        </SelectField>
      )}
    />
  );
}